import cx from 'classnames';

import BPImage from '../../../image';
import useTranslation from 'next-translate/useTranslation';

type TVehicleCardProps = {
  image?: string;
  hasHoverEffect?: boolean;
  boldLine: string;
  lightLine: string;
  vehicleInfo?: { vehicle: any; year: string };
};

const VehicleCard = ({
  image,
  hasHoverEffect = false,
  boldLine,
  lightLine,
  vehicleInfo,
}: TVehicleCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cx({
        'hover:shadow-[0px_0px_6px_rgba(0,0,0,0.2)]': hasHoverEffect,
        'bg-white hover:bg-brand-10': hasHoverEffect,
        'bg-white': !hasHoverEffect,
      })}
    >
      <div className={cx('relative bg-white', 'w-full aspect-video')}>
        <BPImage
          src={image || `${process.env.PUBLIC_PREFIX}/svg/placeholder.svg`}
          layout="fill"
          objectFit="contain"
          objectPosition="center"
          alt={t('common:images_alt.top_models_alt', {
            vehicle: vehicleInfo?.vehicle || '',
            year: vehicleInfo?.year || '',
          })}
          fallbackSrc={`${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`}
        />
      </div>
      <div className="px-4 py-1 ">
        <p className="font-bold text-sm truncate">{boldLine}</p>
        <p className="text-xs">{lightLine}</p>
      </div>
    </div>
  );
};

export default VehicleCard;
